import {SHOP_SETTINGS_PERMISSION, ANALYTICS_EXPLORE} from './permissions';

export default function getRoles(firewall) {
  const roles = [];
  if (firewall.hasAccess(SHOP_SETTINGS_PERMISSION)) roles.push('admin');
  if (firewall.hasAccess(ANALYTICS_EXPLORE)) roles.push('explorer');
  return roles;
}